export const IFRAME_PLUGIN_KEY = 'iframe';
export const IFRAME_TYPE = 'iframe';
